import { useTranslate } from '@refinedev/core';
import { Alert, Flex, theme } from 'antd';

export interface PreviewAlertItem {
  level: 'error' | 'warning' | 'info';
  /** Suffix appended to the caller's `keyPrefix`. */
  key: string;
  /** Interpolation values; `count` also drives the plural form. */
  params: Record<string, string | number>;
}

interface PreviewAlertListProps {
  alerts: PreviewAlertItem[];
  /** i18n namespace the alert keys are resolved against. */
  keyPrefix: string;
}

/** Everything the mobile apps do silently, said out loud. */
export const PreviewAlertList = ({
  alerts,
  keyPrefix,
}: PreviewAlertListProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();

  return (
    <Flex vertical gap={token.marginSM}>
      {alerts.map((alert) => (
        <Alert
          key={alert.key}
          type={alert.level}
          showIcon
          message={t(`${keyPrefix}.${alert.key}`, alert.params)}
        />
      ))}
    </Flex>
  );
};
